import { makeStyles } from "@material-ui/core/styles";

export const palletsUseStyles = makeStyles((theme) => ({
	centeredDatagrid: {
		"& .RaDatagrid-cell": {
			textAlign: "center !important",
		},
		"& .RaDatagrid-cell > *": {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			width: "100%",
		},
		"& td": {
			textAlign: "center !important",
		},
		"& th": {
			textAlign: "center !important",
		},
		"& .MuiTableRow-root:hover": {
			boxShadow: "inset 0 0 0 9999px rgba(0, 0, 0, 0.04)",
		},
	},
	tableRow: {
		height: 60,
		cursor: "pointer",
		"&:hover": {
			boxShadow: "inset 0 0 0 9999px rgba(0, 0, 0, 0.04)",
		},
	},
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		padding: theme.spacing(2),
	},
	modalContent: {
		width: "95vw",
		height: "90vh",
		backgroundColor: theme.palette.background.paper,
		borderRadius: theme.spacing(1),
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2),
		outline: "none",
		overflow: "auto",
	},
	modalHeader: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		marginBottom: theme.spacing(2),
		borderBottom: `1px solid ${theme.palette.divider}`,
		paddingBottom: theme.spacing(1),
	},
	boxList: {
		maxHeight: 400,
		overflow: "auto",
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: theme.spacing(1),
		backgroundColor: theme.palette.background.default,
	},
	boxItem: {
		cursor: "pointer",
		backgroundColor: " white",
		"&:hover": {
			backgroundColor: "#79797979 !important",
		},
	},
	infoCard: {
		padding: theme.spacing(3),
		backgroundColor: theme.palette.background.paper,
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: theme.spacing(2),
		marginBottom: theme.spacing(2),
	},
	infoRow: {
		display: "flex",
		justifyContent: "space-between",
		padding: theme.spacing(1, 0),
		borderBottom: `1px solid ${theme.palette.divider}`,
		"&:last-child": {
			borderBottom: "none",
		},
	},
	infoLabel: {
		fontWeight: 600,
		color: theme.palette.text.secondary,
		minWidth: 140,
	},
	infoValue: {
		fontWeight: 400,
		color: theme.palette.text.primary,
		textAlign: "right",
		flex: 1,
	},
	sectionTitle: {
		color: theme.palette.primary.main,
		fontWeight: 600,
		marginBottom: theme.spacing(2),
		paddingBottom: theme.spacing(1),
		borderBottom: `2px solid ${theme.palette.primary.main}`,
	},
	compactDatagrid: {
		"& .MuiTableRow-root": {
			height: 36,
		},
		"& .MuiTableCell-root": {
			paddingTop: 2,
			paddingBottom: 2,
		},
	},
}));
